<template>
<div></div>
</template>

<script>
export default {
  name: "AdmissionsPage"
}
</script>

<style scoped>

</style>
